<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <b-card class="mb-0">
        <b-link class="brand-logo">
          <b-img
            style="width: 200px;"
            :src="require('@/assets/images/logo/logo.png')"
          />
        </b-link>
        <b-card-title class="mb-1">
          Verificação em Duas Etapas 🔐
        </b-card-title>
        <b-card-text class="mb-2">
          Insira o código de verificação enviado para <strong>{{ userEmail }}</strong> para continuar.
        </b-card-text>
        <validation-observer
          ref="validacaoToken"
          #default="{ invalid }"
        >
          <b-form
            class="auth-login-form mt-2"
            @submit.prevent="validarToken"
          >
            <b-form-group
              label-for="token"
              label="Código de Verificação"
            >
              <validation-provider
                #default="{ errors }"
                name="Token"
                rules="required|length:6"
              >
                <b-form-input
                  id="token"
                  v-model="form.token"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Insira o código de 6 caracteres"
                  type="text"
                  autofocus
                  maxlength="6"
                  pattern="[a-zA-Z0-9]*"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-row class="mb-2">
              <b-col
                cols="12"
                class="text-right"
              >
                <b-link
                  class="text-secondary"
                  @click="reenviarCodigo"
                >
                  <small>Não recebeu o código? Reenviar</small>
                </b-link>
              </b-col>
            </b-row>

            <b-button
              variant="primary"
              type="submit"
              block
              :disabled="invalid || isLoading"
            >
              <b-spinner
                v-if="isLoading"
                small
              />
              <span>{{ isLoading ? 'Verificando...' : 'Verificar' }}</span>
            </b-button>

            <b-row class="mt-2">
              <b-col
                cols="12"
                class="text-center"
              >
                <b-link
                  class="text-secondary"
                  @click="voltarLogin"
                >
                  <feather-icon
                    icon="ArrowLeftIcon"
                    size="14"
                  />
                  <span class="ml-1">Voltar ao login</span>
                </b-link>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </b-card>
    </div>
    <loading
      class="loading"
      :show-cancel-button="false"
      :is-loading="isLoading"
      :titulo-carregamento="'Aguarde!'"
    />
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import api from './shared/services/api'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    Loading: () => import('@pilar/components/loading/Loading.vue'),
  },
  data() {
    return {
      form: {
        token: '',
      },
      isLoading: false,
      usuarioId: null,
      userData: null,
      userEmail: '',
    }
  },
  created() {
    // Receber o ID do usuário dos parâmetros da rota
    if (this.$route.params.usuarioId) {
      this.usuarioId = this.$route.params.usuarioId
      // Receber o email dos parâmetros da rota
      if (this.$route.params.email) {
        this.userEmail = this.$route.params.email
      } else {
        // Tentar buscar do localStorage caso não venha nos parâmetros
        this.userEmail = localStorage.getItem('user_email') || ''
      }
      const savedPayload = localStorage.getItem('auth_payload')
      if (savedPayload) {
        const payload = JSON.parse(savedPayload)
        this.userData = payload.userData
      }
    } else {
      this.$erro('ID do usuário não encontrado nos parâmetros da rota')
      this.$router.push({ name: 'auth-login' })
    }
  },
  methods: {
    validarToken() {
      this.$refs.validacaoToken.validate().then(success => {
        if (success) {
          this.isLoading = true

          const payload = {
            usuarioId: this.usuarioId,
            token: this.form.token,
            email: this.userEmail,
          }

          api.validarTokenDuasEtapas(payload)
            .then(resposta => {
              this.isLoading = false

              if (resposta.data === true) {
                // Token válido
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Sucesso',
                    icon: 'CheckIcon',
                    variant: 'success',
                    text: 'Código validado com sucesso!',
                  },
                })

                this.$router.push({
                  name: 'auth-login',
                  params: { validacaoSucesso: true },
                })
              } else {
                // Token inválido
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: 'Token inválido',
                    icon: 'AlertTriangleIcon',
                    variant: 'danger',
                    text: 'O código informado está incorreto. Tente novamente.',
                  },
                })
              }
            })
            .catch(error => {
              this.isLoading = false

              this.$erro('Erro ao validar código. Contate o administrador.', error)
            })
        }
      })
    },
    reenviarCodigo() {
      this.isLoading = true
      api.gerarTokenDuasEtapas(this.usuarioId, this.userEmail)
        .then(resposta => {
          this.isLoading = false
          if (resposta.data === true) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Enviado',
                icon: 'CheckIcon',
                variant: 'success',
                text: `Um novo código foi enviado para ${this.userEmail}`,
              },
            })
          } else {
            this.$aviso('Erro ao gerar token')
          }
        })
        .catch(error => {
          this.isLoading = false
          this.$erro('Erro na API:', error)
        })
    },
    voltarLogin() {
      // Limpar qualquer dado salvo ao voltar para o login
      localStorage.removeItem('auth_payload')
      localStorage.removeItem('user_email')
      this.$router.push({ name: 'auth-login' })
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";

.auth-wrapper {
  .auth-inner {
    max-width: 400px;
  }
}

.loading {
  .loading_titulo {
    display: flex;
    height: 12%;
  }

  .loading_descricao {
    display: flex;
    height: 14%;
  }
}
</style>
